// TODO recheck eslint
/* eslint-disable */
import React from 'react';
import InnerHTML from '@Components/InnerHTML';
import ShowMoreComponent from '@Components/Results/utils/show-more.component';
import * as Spinners from '@Services/Spinners';
import RxSpinnerComponent from '@Components/Results/utils/rx-spinner.component';
import {
  SubstanceCommercialSupplierInformationCellSupplier
} from '@Components/Results/substances/information/commercial/substance-commercial-supplier-information-cellsupplier.component';
import {
  SubstanceCommercialSupplierInformationCellProduct
} from '@Components/Results/substances/information/commercial/substance-commercial-supplier-information-cellproduct.component';
import {
  SubstanceCommercialSupplierInformationCellPurity
} from '@Components/Results/substances/information/commercial/substance-commercial-supplier-information-cellpurity.component';
import {
  SubstanceCommercialSupplierInformationCellPrice
} from '@Components/Results/substances/information/commercial/substance-commercial-supplier-information-cellprice.component';
import {
  SubstanceCommercialSupplierInformationCellAvailability
} from '@Components/Results/substances/information/commercial/substance-commercial-supplier-information-cellavailability.component';
import Tooltip from '@Components/Tooltip';
import NotificationBar from '@Components/NotificationBar';
import StickyTableHeaderComponent from '@Components/Results/sticky-table-header.component';
import { dispatchStoreProducts, dispatchGetProductsFromStore } from '@Containers/RcsResults/RcsResultsActions';
import RcsCheckboxNew from '@Pages/Results/Containers/RcsCheckboxContainer';
import Auth from '@Services/Auth';
import { FEATURES } from '@Constants/rx-ui/constants';
import size from 'lodash/size';
import find from 'lodash/find';
import isArray from 'lodash/isArray';
import { HEATMAP_CELL_DETAILS_DIALOG_CONTENT_CLASS_NAME } from '@Pages/Heatmap/HeatmapCellDetailsDialog/constants';

import './substance-commercial-supplier-information.custom.scss';

export default class SubstanceCommercialSupplierInformation extends React.PureComponent {

  constructor(props) {
    super(props);

    const { data, uniqueId } = props;

    this.state = {
      data,
      headersReady: false
    };
    this.cache = null;
    this.id = `${uniqueId}-commercialSuppliers`;
    this.isProdSelectionEnabled = Auth.isFeatureEnabled(FEATURES.enableProductSelection);
    this.isRcsExport = Auth.getUser().details.databases[props.metadata.databaseId].name === "Commercial Substances";
    if (this.isRcsExport && this.isProdSelectionEnabled) {
      this.storeProducts();
    }
  }

  componentDidMount() {
    Tooltip.rebuild();
  }

  showMore(firstItem = 1, lastItem = this.props.initialItemsAmount) {
    return new Promise((resolve, reject) => {
      if (this.cache) {
        this.appendRows(this.cache);
        this.cache = null;
        return resolve();
      }

      Spinners.activate(this.id);

      return this.props
        .retrieveData(firstItem, lastItem)
        .then(({ commercialData }) => {
          const { substanceId } = this.props;
          const products = dispatchGetProductsFromStore();
          if (size(products[this.props.substanceId]) !== lastItem) {
            const data = this.state.data?.concat(commercialData);
            if (Object.values(products).length !== 0 && products[this.props.substanceId] !== undefined) {
              Object.values(products[this.props.substanceId]).forEach(function(prod) {
                //updating the checked info for the initial 8 displayed products
                const productItem = find(data, (product) => product.rcSubstanceId === prod.rcSubstanceId);
                if (productItem) {
                  productItem.checked = prod.checked;
                }
              });
            }
            dispatchStoreProducts({ substanceId, data });
          }
          this.appendRows(commercialData);
          this.props.track && this.props.track(commercialData, "showMoreCommercialData", null, firstItem, lastItem);
          return commercialData;
        })
        .catch(() => reject(new Error("No commercial suppliers data found")))
        .finally(() => {
          Tooltip.rebuild();
          Spinners.terminate(this.id);
          return resolve();
        });
    });
  }

  appendRows(rows) {
    let data = [...this.state.data];
    data = data?.concat(rows);
    this.setState({ data });
  }

  showLess() {
    let data = [...this.state.data];
    this.cache = data?.splice(this.props.initialItemsAmount);
    data = [...data];
    this.setState({ data });
  }

  storeProducts() {
    const { substanceId } = this.props;
    const { data } = this.state;

    dispatchStoreProducts({ substanceId, data });
  }

  render() {
    const { metadata, total, initialItemsAmount, details, substanceId, substanceIndex } = this.props;
    const scrollContainerSelector = metadata.heatmapMode ? `.${HEATMAP_CELL_DETAILS_DIALOG_CONTENT_CLASS_NAME}` : null;
    const { headersReady, data } = this.state;
    const { casRegistryNumbers } = details;
    const handledCasRegistryNumbers = isArray(casRegistryNumbers) ? casRegistryNumbers.join(", ") : casRegistryNumbers;
    const headers = [];

    if (this.isProdSelectionEnabled && this.isRcsExport) {
      headers.push({
        id: "selected",
        cssid: "checkbox",
        order: 0,
        hasContent: false,
        isVisible: true
      });
    }

    headers.push({
      id: "supplier",
      title: "Commercial Suppliers",
      cssid: "supplier",
      order: 1,
      hasContent: true,
      isVisible: true
    }, {
      id: "product",
      cssid: "product",
      title: "Product",
      order: 2,
      hasContent: true,
      isVisible: true
    }, {
      id: "purity",
      cssid: "purity",
      title: "Purity",
      order: 3,
      hasContent: true,
      isVisible: true
    }, {
      id: "size-price",
      cssid: "size-price",
      title: "Package size & price",
      colspan: "2",
      order: 4,
      hasContent: true,
      isVisible: true
    }, {
      id: "availability",
      cssid: "availability",
      title: "Availability",
      order: 5,
      hasContent: true,
      isVisible: true
    });

    return (
      <div
        id={this.id}
        className="substance-results-commercial-information typography-small"
        aria-expanded={true}>
        <table className="rx-table rx-table--full-width sticky-table-header">
          <StickyTableHeaderComponent headers={headers} staticColumns="true">
            <NotificationBar id="rcs-price-notify" type="info" parentType="table"
                             content="Please take a moment to check individual supplier websites for the most up-to-date information on pricing and availability" />
          </StickyTableHeaderComponent>
          <tbody>
          {data?.map(
            (item, index) => (
              <tr key={index}>
                {this.isProdSelectionEnabled ?
                  (<td>
                    <RcsCheckboxNew
                      substanceId={substanceId}
                      substanceIndex={substanceIndex}
                      productId={item.rcSubstanceId}
                      productIndex={item.index}
                    />
                  </td>) : null}
                <SubstanceCommercialSupplierInformationCellSupplier {...item} databaseId={metadata.databaseId}
                                                                    casRegistryNumbers={handledCasRegistryNumbers} />
                <SubstanceCommercialSupplierInformationCellProduct {...item}
                                                                   casRegistryNumbers={handledCasRegistryNumbers} />
                <SubstanceCommercialSupplierInformationCellPurity {...item} />
                <InnerHTML tag="td" className="column-size" html={item.packageSize} />
                <SubstanceCommercialSupplierInformationCellPrice {...item} />
                <SubstanceCommercialSupplierInformationCellAvailability {...item} />
              </tr>
            )
          )}
          </tbody>
        </table>

        <RxSpinnerComponent spinnerId={this.id} position="relative" />

        <div className="rx-btn-group--center">
          <ShowMoreComponent
            initial={initialItemsAmount}
            scrollContainerSelector={scrollContainerSelector}
            metadata={metadata}
            current={data?.length}
            total={total}
            container={`#${this.id}`}
            moreHandler={({ firstItem, lastItem }) => this.showMore(firstItem, lastItem)}
            lessHandler={() => this.showLess()}
          />
        </div>
      </div>
    );
  }
}
